// Mason Genie PDP v2: bundle selection, quantity add-to-cart, countdown, sticky bars,
// mobile gallery, accordions, FAQ, review tabs, kit hotspots.
// Bundles are quantities of the same product; the vg-cart drawer applies the
// SPECIALOFFER quantity-tier discount codes at checkout.
(function () {
  function init(root) {
    if (!root) return;

    // ---- Bundle card selection ----
    var kits = root.querySelectorAll('[data-mg2-kit]');
    var selected = root.querySelector('[data-mg2-kit].is-selected') || kits[0];

    function applySelection(card) {
      selected = card;
      kits.forEach(function (k) { k.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      var d = card.dataset;
      root.querySelectorAll('[data-mg2-summary-name], [data-mg2-selected-name]').forEach(function (el) { el.textContent = d.mg2Name; });
      root.querySelectorAll('[data-mg2-summary-price]').forEach(function (el) { el.textContent = d.mg2Price; });
      root.querySelectorAll('[data-mg2-price-num]').forEach(function (el) { el.textContent = d.mg2Price; });
      root.querySelectorAll('[data-mg2-summary-compare]').forEach(function (el) { el.textContent = d.mg2Compare + ' value'; });
      root.querySelectorAll('[data-mg2-compare-num]').forEach(function (el) { el.textContent = d.mg2Compare; });
      root.querySelectorAll('[data-mg2-save-label]').forEach(function (el) { el.textContent = d.mg2Save; });
      // Per-unit price shown in the "What's In Every Kit" sale line ($49.99 each / $44.99each)
      root.querySelectorAll('[data-mg2-unit-num]').forEach(function (el) { el.textContent = d.mg2Unit || d.mg2Price; });
    }

    kits.forEach(function (card) {
      card.addEventListener('click', function () { applySelection(card); });
    });
    if (selected) applySelection(selected);

    // ---- Add to cart (quantity of the single Mason Genie variant) ----
    var variantId = null;
    root.querySelectorAll('[data-mg2-variant-id]').forEach(function (el) {
      variantId = parseInt(el.dataset.mg2VariantId, 10) || variantId;
    });
    root.querySelectorAll('[data-mg2-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!selected || !variantId) return;
        var qty = parseInt(selected.dataset.mg2Qty, 10) || 1;

        // Optimistic: open the drawer immediately with this kit rendered (the
        // vg-cart opt-add event), instead of making the visitor wait for the
        // server round trip. Falls back to the old flow when the section markup
        // doesn't carry the data-mg2-opt-* line data.
        var optEl = root.querySelector('[data-mg2-opt-title]');
        var optimistic = false;
        // Free gifts this add qualifies for (?offer= links) go in the same request.
        var gifts = [];
        try { if (window.__mgGiftsForAdd && optEl) gifts = window.__mgGiftsForAdd(optEl.dataset.mg2OptHandle || '', qty, parseInt(optEl.dataset.mg2OptPrice, 10) || 0) || []; } catch (e) { gifts = []; }
        if (optEl) {
          var od = optEl.dataset;
          var det = {
            id: variantId, qty: qty,
            title: od.mg2OptTitle, handle: od.mg2OptHandle || '',
            image: od.mg2OptImage || '', url: '',
            price: parseInt(od.mg2OptPrice, 10) || 0,
            gifts: gifts
          };
          if (det.price) {
            optimistic = true;
            document.dispatchEvent(new CustomEvent('vg:cart:open'));
            document.dispatchEvent(new CustomEvent('vg:cart:opt-add', { detail: det }));
          }
        }
        if (!optimistic) btn.style.opacity = '.6';

        var addItems = function (list) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: list })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          });
        };
        var kitLine = [{ id: variantId, quantity: qty }];
        // If a gift line is ever rejected, retry the kit alone — a gift problem
        // must never block the sale (the drawer's own gift sync then retries).
        addItems(kitLine.concat(gifts.map(function (id) { return { id: id, quantity: 1 }; })))
          .catch(function (err) { if (!gifts.length) throw err; return addItems(kitLine); })
          .then(function () {
            btn.style.opacity = '';
            if (optimistic) {
              document.dispatchEvent(new CustomEvent('vg:cart:opt-settle'));
            } else {
              document.dispatchEvent(new CustomEvent('vg:cart:open'));
              document.dispatchEvent(new CustomEvent('vg:cart:changed'));
            }
          })
          .catch(function (err) {
            btn.style.opacity = '';
            // Settle triggers a refresh, which removes the optimistic line the
            // server never received — the drawer ends up truthful again.
            if (optimistic) document.dispatchEvent(new CustomEvent('vg:cart:opt-settle'));
            console.error('[mg2-pdp] add to cart failed', err);
            alert('Sorry, something went wrong adding to cart. Please try again.');
          });
      });
    });

    // Smooth scroll up to the buy box (#mg2-offer carries scroll-margin-top:90px, so
    // the bundle cards AND the main Add to Cart both land in view).
    // Native smooth is used deliberately: it's browser-tuned and honours the user's
    // prefers-reduced-motion setting. The timeout is only a safety net for the case
    // where the animation never starts at all (e.g. a backgrounded/hidden page, where
    // browsers suspend both rAF and smooth scrolling) — it does not interrupt a
    // running animation, because by then the page will already have moved.
    function mg2ScrollToOffer(isCorrection) {
      var offer = document.getElementById('mg2-offer');
      if (!offer) return;
      // The landing offset is authored in CSS (scroll-margin-top on #mg2-offer,
      // responsive) — read it so this math always matches scrollIntoView.
      var off = parseFloat(getComputedStyle(offer).scrollMarginTop) || 0;
      var startY = window.pageYOffset;
      var targetY = Math.max(0, offer.getBoundingClientRect().top + startY - off);
      if (Math.abs(targetY - startY) < 2) return;
      offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () {
        if (Math.abs(window.pageYOffset - startY) < 4) window.scrollTo(0, targetY);
        // When this PDP is stacked under a listicle the scroll can be very long,
        // and lazy-loaded media mounting mid-flight shifts the target. Re-measure
        // once it has settled and correct. One correction only — never a loop.
        if (isCorrection === true) return;
        var want = Math.max(0, offer.getBoundingClientRect().top + window.pageYOffset - off);
        if (Math.abs(want - window.pageYOffset) > 80) mg2ScrollToOffer(true);
      }, 750);
    }

    // ---- Sticky CTA, "scroll" A/B variant: jump to the buy box instead of adding ----
    root.querySelectorAll('[data-mg2-sticky-scroll]').forEach(function (btn) {
      btn.addEventListener('click', mg2ScrollToOffer);
    });

    // ---- Section CTAs scroll back to the offer ----
    root.querySelectorAll('[data-mg2-cta]').forEach(function (btn) {
      btn.addEventListener('click', mg2ScrollToOffer);
    });

    // ---- Cart icon opens drawer ----
    root.querySelectorAll('[data-vg-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('vg:cart:open'));
      });
    });

    // ---- Countdown to local midnight ----
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(23, 59, 59, 999);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      root.querySelectorAll('[data-mg2-cd-h]').forEach(function (el) { el.textContent = pad(Math.floor(d / 3600)); });
      root.querySelectorAll('[data-mg2-cd-m]').forEach(function (el) { el.textContent = pad(Math.floor((d % 3600) / 60)); });
      root.querySelectorAll('[data-mg2-cd-s]').forEach(function (el) { el.textContent = pad(d % 60); });
    }
    tick();
    setInterval(tick, 1000);

    // ---- Ships by: always Tomorrow ----
    var shipsBy = 'Tomorrow';
    root.querySelectorAll('[data-mg2-ships-by]').forEach(function (el) { el.textContent = shipsBy; });

    // ---- Sticky bars ----
    // Both bars appear as soon as the FIRST bundle card scrolls out of view,
    // so an Add to Cart is always one tap away.
    var stickies = root.querySelectorAll('[data-mg2-sticky]');
    var firstKit = root.querySelector('[data-mg2-kit]');
    // When this PDP is stacked under a listicle, that listicle renders the page's
    // mobile sticky CTA (its own offer button, live from reason 2 onward). Stand
    // our mobile bar down so the page never shows two bottom bars. The desktop
    // top bar is unaffected — the listicle bar is mobile-only.
    var listicleOwnsMobileBar = !!document.querySelector('.vgl-sticky');
    function onScroll() {
      var pastKit = firstKit ? firstKit.getBoundingClientRect().bottom < 0 : false;
      stickies.forEach(function (el) {
        var on = pastKit && !(listicleOwnsMobileBar && el.classList.contains('mg-sticky-bottom'));
        el.classList.toggle('is-on', on);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // ---- Mobile gallery thumbs ----
    var mainImg = root.querySelector('[data-mg2-mobile-main]');
    root.querySelectorAll('[data-mg2-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-mg2-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg && thumb.dataset.mg2Full) mainImg.src = thumb.dataset.mg2Full;
      });
    });

    // ---- Buy box accordions ----
    root.querySelectorAll('[data-mg2-acc]').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.vg-acc');
        var open = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.vg-acc.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var s = o.querySelector('[data-mg2-acc-sign]');
          if (s) s.textContent = '+';
        });
        if (!open) {
          item.classList.add('is-open');
          var sign = item.querySelector('[data-mg2-acc-sign]');
          if (sign) sign.textContent = '−';
        }
      });
    });

    // ---- FAQ ----
    root.querySelectorAll('[data-mg2-faq]').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.vg-faq');
        var open = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.vg-faq.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var s = o.querySelector('[data-mg2-faq-sign]');
          if (s) s.textContent = '+';
        });
        if (!open) {
          item.classList.add('is-open');
          var sign = item.querySelector('[data-mg2-faq-sign]');
          if (sign) sign.textContent = '−';
        }
      });
    });

    // ---- Review tabs ----
    var tabs = root.querySelectorAll('[data-mg2-tab]');
    var panels = root.querySelectorAll('[data-mg2-tabpanel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var i = tab.dataset.mg2TabI;
        panels.forEach(function (p) { p.classList.toggle('mg2-hidden', p.dataset.mg2Tabpanel !== i); });
      });
    });

    // ---- Customer video tiles (buy-box rail + reviews rail) ----
    // No autoplay: tiles show their first frame. Play button starts the video
    // WITH sound; tapping again pauses it (which also kills the sound). Playing
    // one tile pauses whichever other tile was playing.
    var rvTiles = root.querySelectorAll('.mg2-rvid');
    function rvSync(tile) {
      var v = tile.querySelector('[data-mg2-rv]');
      tile.classList.toggle('is-playing', !v.paused);
    }
    function rvPauseOthers(except) {
      rvTiles.forEach(function (t) {
        var v = t.querySelector('[data-mg2-rv]');
        if (v !== except && !v.paused) { v.pause(); rvSync(t); }
      });
    }
    rvTiles.forEach(function (tile) {
      var v = tile.querySelector('[data-mg2-rv]');
      var toggle = tile.querySelector('[data-mg2-rv-toggle]');
      if (toggle) toggle.addEventListener('click', function () {
        if (!v.getAttribute('src') && v.dataset.mg2Vsrc) v.src = v.dataset.mg2Vsrc;
        if (v.paused) {
          rvPauseOthers(v);
          v.muted = false;
          v.play();
        } else {
          v.pause();
        }
        rvSync(tile);
      });
      rvSync(tile);
    });

    // ---- Lazy-load videos as they approach the viewport ----
    // Nothing below the fold downloads until the visitor scrolls near it; the
    // silent loop videos (steps / use-cases) then start themselves.
    var lazyVids = root.querySelectorAll('video[data-mg2-vsrc]');
    function loadVid(v) {
      if (v.getAttribute('src')) return;
      v.src = v.dataset.mg2Vsrc;
      if (v.hasAttribute('data-mg2-vauto')) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { loadVid(e.target); vio.unobserve(e.target); }
        });
      }, { rootMargin: '400px 0px' });
      lazyVids.forEach(function (v) { vio.observe(v); });
    } else {
      lazyVids.forEach(loadVid);
    }

    // ---- Review-video rail: mobile arrows + dots ----
    var rail = root.querySelector('[data-mg2-rail]');
    if (rail) {
      var dots = root.querySelectorAll('.mg2-rail-dot');
      function railStep() {
        var card = rail.firstElementChild;
        if (!card) return 0;
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 14;
        return card.getBoundingClientRect().width + gap;
      }
      function railDots() {
        var step = railStep();
        if (!step) return;
        var i = Math.min(dots.length - 1, Math.max(0, Math.round(rail.scrollLeft / step)));
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      }
      var prev = root.querySelector('[data-mg2-rail-prev]');
      var next = root.querySelector('[data-mg2-rail-next]');
      // Instant scrollLeft assignment + direct dot refresh: smooth scrolling and
      // even scroll events can stall while five videos are compositing.
      if (prev) prev.addEventListener('click', function () { rail.scrollLeft -= railStep(); railDots(); });
      if (next) next.addEventListener('click', function () { rail.scrollLeft += railStep(); railDots(); });
      rail.addEventListener('scroll', railDots, { passive: true });
      railDots();
    }

    // ---- Kit hotspots (desktop "What's In Every Kit") ----
    function selectKitItem(i) {
      root.querySelectorAll('[data-mg2-dot]').forEach(function (d) { d.classList.toggle('is-on', d.dataset.mg2I === i); });
      root.querySelectorAll('[data-mg2-kitrow]').forEach(function (r) { r.classList.toggle('is-on', r.dataset.mg2I === i); });
    }
    root.querySelectorAll('[data-mg2-dot], [data-mg2-kitrow]').forEach(function (el) {
      el.addEventListener('click', function () { selectKitItem(el.dataset.mg2I); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mg2-pdp]').forEach(init);
  });
})();
